import React from 'react'

import { IDeliveryTreeNode } from '~/client/src/shared/models/IDeliveryTreeNode'

interface IProps {
  node: IDeliveryTreeNode
  shouldHideAmount?: boolean
}

export default class DeliveryLocationContainerNode extends React.Component<IProps> {
  public render() {
    const {
      shouldHideAmount,
      node: { name, totalEntitiesAmount },
    } = this.props
    const title = totalEntitiesAmount ? String(totalEntitiesAmount) : ''

    return (
      <>
        <div className="text extra large white bold">{name}</div>
        {!shouldHideAmount && (
          <div className="text large white right pr20">{title}</div>
        )}
      </>
    )
  }
}
